module.exports = __webpack_public_path__ + "img/coffee-grinded.67eb260c.png";